export default __webpack_public_path__ + "static/feature-importances-long--mobile-158ab5d2fc3935e55b0702e7f1a60c1d.webp";